import React, { useEffect } from 'react'
import _ from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { Switch, Select, Button } from 'antd'
import styled from 'styled-components/macro'
import { Col } from 'styled-bootstrap-grid'
import { SelectValue } from 'antd/lib/select'
import { NavProps, WizardNavigationWrapper, WizardNav } from '../../../components/Wizard/WizardNav'
import { isValidating, getFlowValidationResult, selectedFlow } from '../../../features/flow/selectors'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import { Label, CenteredRow } from '../../../components/Page/Layout'
import { Row } from '../../../components/Grid'
import { getHooks } from '../../../features/hook/selectors'
import { Hook } from '../../../features/hook/types'
import { HookActions } from '../../../features/hook/actions'
import { FlowActions } from '../../../features/flow/actions'
import { SectionEnum } from './types'

const { Option } = Select

const RightDiv = styled.div`
  float: right;
`

const ColumnWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-row-gap: 40px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

  /* div {
    text-align: center;
  } */
  .ant-switch {
    margin-top: 6px;
    margin-bottom: 6px;
  }
`

const StyledSelect = styled(Select)`
  width: 200px;
  margin-left: 12px;
`

type AddFlowSectionsProps = {
  close?: () => void
} & NavProps

export const AddFlowSections: React.FC<AddFlowSectionsProps> = ({ close, ...rest }: AddFlowSectionsProps) => {
  const dispatch = useDispatch()
  const loading = useSelector(isValidating)
  const status = useSelector(getFlowValidationResult)
  const flow = useSelector(selectedFlow)

  const hooks = useSelector(getHooks)

  useEffect(() => {
    let load = false
    const loadData = async () => {
      if (!load) {
        dispatch(HookActions.fetchHooks())
        load = true
      }
    }
    loadData()
  }, [dispatch])

  function changeSwitchHandler(field: SectionEnum, checked: boolean) {
    if (flow && flow.name) {
      const oldValue = flow[field]
      const flowToValidate = { ...flow, [field]: { ...oldValue, enabled: checked } }
      dispatch(FlowActions.updateNewFlow(flowToValidate))
    }
  }

  function changeHookHandler(field: SectionEnum, value: SelectValue) {
    if (flow && flow.name) {
      const oldValue = flow[field]
      const flowToValidate = { ...flow, [field]: { ...oldValue, hook: value } }
      dispatch(FlowActions.updateNewFlow(flowToValidate))
    }
  }

  if (!flow) return <LoadingOverlay loading>&nbsp;</LoadingOverlay>

  const makeSection = (section: SectionEnum) => {
    return (
      <div key={`wrapper-${section}`}>
        <Label>Sezione {section}</Label>
        <Switch
          checkedChildren={<span>Attiva</span>}
          unCheckedChildren={<span>Disattiva</span>}
          defaultChecked
          checked={flow[section]?.enabled || false}
          onChange={(c: boolean) => changeSwitchHandler(section, c)}
        />
        {flow[section]?.enabled ? null : (
          <StyledSelect
            value={flow[section]?.hook || 1}
            onChange={(value: SelectValue) => changeHookHandler(section, value)}
          >
            {_.map(hooks, (h: Hook) => (
              <Option key={h.id} value={h.id}>
                {h.name}
              </Option>
            ))}
          </StyledSelect>
        )}
      </div>
    )
  }

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        <CenteredRow>seleziona le Sezioni attive o gli Hook per quelle inattive</CenteredRow>
        <Row>
          <Col md={8} mdOffset={2}>
            <ColumnWrapper>
              {_.map(['radar', 'chat', 'profile', 'notifications', 'match'], (section: SectionEnum) =>
                makeSection(section)
              )}
            </ColumnWrapper>
          </Col>
        </Row>
        <WizardNavigationWrapper>
          <WizardNav {...rest} nextDisabled={!status?.isValid} />
        </WizardNavigationWrapper>
      </div>
      <RightDiv>
        <Button onClick={close}>Chiudi</Button>
      </RightDiv>
    </LoadingOverlay>
  )
}
